// extracted by mini-css-extract-plugin
export default {"upload":"photoList_upload__WedD7","error":"photoList_error__iyk5s"};